// SHARED PRODUCT DATA (Single source of truth)

import {graph_data_xbo8} from "./graph_data_8"
import {graph_data_xbo14} from "./graph_data_14"
import {graph_data_xbo20} from "./graph_data_20"
import {combinationOCXO1} from "./partNumberCombinationData"
import {combinationOCXOcsac} from "./partNumberCombinationDataCsac"

export const PRODUCTS_BASE_DATA = [
  {
    id: 1,
    caption: "“Atomic” precision low power clocks - CSAC alternative",
    title:"CSAC replacement",
    color: "bg-slate-50/70 dark:bg-slate-900/50 border-x border-slate-200 dark:border-slate-800",
    headerGradient: "from-[#4f5aa3] to-[#5c67aa]",
    pdfUrl: "/specs/xbc-series-specification.pdf",
    layoutOcxoParams: "A1LayoutOcxoParams",
    //isLowPower: true,
    specifications: [
      { label: "Stability", value: "0.5 ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
      { label: "Allan Deviation", value: "5E-13/1s", icon: 'AudioLines', mobileDisplay: true },
          
    ],
    products: [
      { 
        id: "1.1", 
        name: "XBC25", 
        title:"CSAC Alternative",
        relativeData: "XBC25 25.8x25.8x12.7 mm", //add
        partNumberServiceData:  combinationOCXOcsac,
        pdfUrl: "/pimages/03_pdf/XBC25.pdf",
        description: "Ultra-high precision small size clocks", 
        size: "25.8x25.8x12.7 mm", 
        color: "bg-gradient-to-br from-blue-100 to-blue-200",
        image: "/viewer/200_25.png",
        scaleImage: 0.9,
        modelParamsComponentCode: 2, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8.192, 16.384, 8-120 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Output", value: "1 PPS & 10 MHz", icon: 'Cpu', mobileDisplay: true },
          { label: "Aging", value: "to 0.5 ppb/month", icon: 'CalendarClock', mobileDisplay: true },
          { label: "Stability", value: "0.5 ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },      
          { label: "Consumption", value: "<100 mW", icon: 'Zap', mobileDisplay: true },      
        ],
        availableMultipliers: null, //add
        data: null, //add
        imagesViewer:[
            {
              large: "/viewer/400_25.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_25.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XBO25",
            },
    
        ],
        toDo: [],
      },
      { 
        id: "1.2", 
        name: "XBC25A", 
        title:"CSAC replacement",
        relativeData: "XBC25A 40.6x35.3x14.3 mm", //add
        partNumberServiceData:  combinationOCXOcsac,
        pdfUrl: "/pimages/03_pdf/XBC25.pdf",
        description: "Full-functional CSAC replacement", 
        size: "40.6x35.3x14.3 mm", 
        color: "bg-gradient-to-br from-blue-200 to-blue-300",
        image: "/viewer/200_25a.png",
        scaleImage: 1,
        modelParamsComponentCode: 2, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8.192, 16.384 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Output", value: "1 PPS & 10 MHz", icon: 'Cpu', mobileDisplay: true },
          { label: "Aging", value: "to 0.5 ppb/month", icon: 'CalendarClock', mobileDisplay: true },
          { label: "Stability", value: "0.5 ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true }, 
          { label: "Consumption", value: "<100 mW", icon: 'Zap', mobileDisplay: true },           
        ],
        availableMultipliers: null, //add
        data: null, //add
        imagesViewer:[
            {
              large: "/viewer/400_25a.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_25a.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XBO25A",
            },
     
        ]
      },
    ]  
  },
  {
    id: 2,
    caption: "Ultra-stable low phase-noise low power OCXOs",
    title:"Ultra-stable low phase-noise",
    color: "bg-slate-50/70 dark:bg-slate-900/50 border-x border-slate-200 dark:border-slate-800",
    headerGradient: "from-[#4f5aa3] to-[#5c67aa]",
    pdfUrl: "/specs/xbo-series-specification.pdf",
    layoutOcxoParams: "A2LayoutOcxoParams",
    //isLowPower: true,
    specifications: [
      { label: "Stability", value: "0.5 ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
      { label: "Allan Deviation", value: "5E-13/1s", icon: 'AudioLines', mobileDisplay: true },
      { label: "Phase Noise @1Hz", value: "-120 dBc/1Hz", icon: 'BarChart3', mobileDisplay: true },     
    ],
    products: [
      { 
        id: "2.1", 
        name: "XBO20",
        title:"Ultra-stable low noise",
        relativeData: "XBO20 20.2x20.2x12.6 mm", //add
        partNumberServiceData:  combinationOCXO1,
        pdfUrl: "/pimages/03_pdf/XBO20.pdf",
        size: "20.2x20.2x12.6 mm", //correct
        color: "bg-gradient-to-br from-purple-100 to-purple-200",
        image: "/viewer/200_20.png", //correct
        scaleImage: 0.8,
        modelParamsComponentCode: 1, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8-150 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Stability", value: "0.5 ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
          { label: "Aging", value: "0.5 ppb/month", icon: 'CalendarClock', mobileDisplay: true },
          { label: "Phase Noise", value: "-118 dBc/Hz@1Hz", icon: 'BarChart3', mobileDisplay: false },     
          { label: "Consumption", value: "<110 mW", icon: 'Zap', mobileDisplay: true },     
        ],
        availableMultipliers: graph_data_xbo20.availableMultipliers, //add
        data: graph_data_xbo20.data, //add
        imagesViewer:[
            {
              large: "/viewer/400_20.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_20.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XB20",
            },
 
        ]
      },
      { 
        id: "2.2", 
        name: "XBO20S",
        title:"Ultra-stable low noise",
        relativeData: "XBO20S 25.4x22x11.2 mm", //add
        partNumberServiceData:  combinationOCXO1,
        pdfUrl: "/pimages/03_pdf/XBO20.pdf",
        size: "25.4x22x11.2 mm", //correct
        color: "bg-gradient-to-br from-purple-200 to-purple-300",
        image: "/viewer/200_20s.png", //correct
        scaleImage: 0.8,
        modelParamsComponentCode: 1, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8-150 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Stability", value: "0.5 ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
          { label: "Aging", value: "0.5 ppb/month", icon: 'CalendarClock', mobileDisplay: true },
          { label: "Phase Noise", value: "-118 dBc/Hz@1Hz", icon: 'BarChart3', mobileDisplay: false },  
          { label: "Consumption", value: "<110 mW", icon: 'Zap', mobileDisplay: true },      
        ],
        availableMultipliers: graph_data_xbo20.availableMultipliers, //add
        data: graph_data_xbo20.data, //add
        imagesViewer:[
            {
              large: "/viewer/400_20s.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_20s.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XBO20S",
            },
     
        ]
      },
      { 
        id: "2.3", 
        name: "XBO25", 
        title:"Ultra-stable low noise",
        relativeData: "XBO25 25.8x25.8x12.7 mm", //add
        partNumberServiceData:  combinationOCXO1,
        pdfUrl: "/pimages/03_pdf/XBC25.pdf",
        size: "25.8x25.8x12.7 mm", 
        color: "bg-gradient-to-br from-purple-300 to-purple-400",
        image: "/viewer/200_25.png",
        scaleImage: 1,
        modelParamsComponentCode: 1, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8-120 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Stability", value: "0.5 ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
          { label: "Aging", value: "0.5 ppb/month", icon: 'CalendarClock', mobileDisplay: true },
          { label: "Phase Noise", value: "-118 dBc/Hz@1Hz", icon: 'BarChart3', mobileDisplay: false },     
          { label: "Consumption", value: "<110 mW", icon: 'Zap', mobileDisplay: true },    
        ],
        availableMultipliers: graph_data_xbo20.availableMultipliers, //add
        data: graph_data_xbo20.data, //add
        imagesViewer:[
            {
              large: "/viewer/400_25.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_25.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XBO25",
            },

        ]
      }
    ]
  },
  {
    id: 3,
    caption: "Low power high stability miniature OCXOs",
    title:"high stability",
    color: "bg-slate-50/70 dark:bg-slate-900/50 border-x border-slate-200 dark:border-slate-800",
    headerGradient: "from-[#4f5aa3] to-[#5c67aa]",
    pdfUrl: "/specs/xbo-miniature-specification.pdf",
    layoutOcxoParams: "A2LayoutOcxoParams",
    //isLowPower: true,
    specifications: [
      { label: "Stability", value: "to 1 ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },      
      { label: "Allan Deviation", value: "5E-12/1s", icon: 'AudioLines', mobileDisplay: true },
      { label: "Phase Noise @1Hz", value: "-110 dBc/1Hz", icon: 'BarChart3', mobileDisplay: true },
           
    ],
    products: [
      { 
        id: "3.1", 
        name: "XBO8",
        title:"high stability DIP8",
        relativeData: "XBO8 16x15.3x15.8 mm", //add
        partNumberServiceData:  combinationOCXO1,
        pdfUrl: "/pimages/03_pdf/XBO8.pdf",
        size: "16x15.3x9.5", //correct ???
        color: "bg-gradient-to-br from-emerald-100 to-emerald-200",
        image: "/viewer/200_8.png", //correct
        scaleImage: 0.6,
        modelParamsComponentCode: 1, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8-150 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Stability", value: "to 2ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
          { label: "Aging", value: "0.1 ppb/day", icon: 'CalendarClock', mobileDisplay: true },          
          { label: "Phase Noise", value: "-105 dBc/Hz@1Hz", icon: 'BarChart3', mobileDisplay: true },
          { label: "Consumption", value: "<100 mW", icon: 'Zap', mobileDisplay: true }, 
         ],
        availableMultipliers: graph_data_xbo8.availableMultipliers, //add
        data: graph_data_xbo8.data, //add
        imagesViewer:[
            {
              large: "/viewer/400_8.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_8.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XBO8",
            },
  
        ]
      },
      { 
        id: "3.2", 
        name: "XBO8S",
        title:"high stability DIP8 SMD",
        relativeData: "XBO8S 16x15.24x9.5 mm", //add
        partNumberServiceData:  combinationOCXO1,
        pdfUrl: "/pimages/03_pdf/XBO8.pdf",
        size: "16x15.24x9.5", //correct ???
        color: "bg-gradient-to-br from-emerald-200 to-emerald-300",
        image: "/viewer/200_8s.png", //correct //imagePath: "./pimages/img_axl/02_products"
        scaleImage: 0.6,
        modelParamsComponentCode: 1, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8-150 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Stability", value: "2ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
          { label: "Aging", value: "0.1 ppb/day", icon: 'CalendarClock', mobileDisplay: true },
          { label: "Phase Noise", value: "-105 dBc/Hz@1Hz", icon: 'BarChart3', mobileDisplay: true },
          { label: "Consumption", value: "<100 mW", icon: 'Zap', mobileDisplay: true }, 
         ],
        availableMultipliers: graph_data_xbo8.availableMultipliers, //add
        data: graph_data_xbo8.data, //add
        imagesViewer:[
            {
              large: "/viewer/400_8s.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_8s.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XBO8S",
            },
  
        ]
      },
      { 
        id: "3.3", 
        name: "XBO14", 
        title:"high stability DIP14",
        relativeData: "XBO14 20.5x15.3x15.8 mm", //add
        partNumberServiceData:  combinationOCXO1,
        pdfUrl: "/pimages/03_pdf/XBO14.pdf",
        size: "20.5x15.3x15.8 mm", 
        color: "bg-gradient-to-br from-emerald-300 to-emerald-400",
        image: "/viewer/200_14.png",
        scaleImage: 0.7,
        modelParamsComponentCode: 1, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8-150 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Stability", value: "1ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
          { label: "Aging", value: "0.1 ppb/day", icon: 'CalendarClock', mobileDisplay: true },
          { label: "Phase Noise", value: "-110 dBc/Hz@1Hz", icon: 'BarChart3', mobileDisplay: true },
          { label: "Consumption", value: "<100 mW", icon: 'Zap', mobileDisplay: true }, 
         ],
        availableMultipliers: graph_data_xbo14.availableMultipliers, //add
        data: graph_data_xbo14.data, //add
        imagesViewer:[
            {
              large: "/viewer/400_14.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_14.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XBO14",
            },
   
        ]
      },
      { 
        id: "3.4", 
        name: "XBO14S", 
        title:"high stability DIP14 SMD",
        relativeData: "XBO14S 20.5x15.3x9.5 mm", //add
        partNumberServiceData:  combinationOCXO1,
        pdfUrl: "/pimages/03_pdf/XBO14.pdf",
        size: "20.5x15.3x9.5", 
        color: "bg-gradient-to-br from-emerald-400 to-emerald-500",
        image: "/viewer/200_14s.png",
        scaleImage: 0.7,
        modelParamsComponentCode: 1, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8-150 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Stability", value: "1ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
          { label: "Aging", value: "0.1 ppb/day", icon: 'CalendarClock', mobileDisplay: true },
          { label: "Phase Noise", value: "-110 dBc/Hz@1Hz", icon: 'BarChart3', mobileDisplay: true },
          { label: "Consumption", value: "<100 mW", icon: 'Zap', mobileDisplay: true }, 
         ],
        availableMultipliers: graph_data_xbo14.availableMultipliers, //add
        data: graph_data_xbo14.data, //add
        imagesViewer:[
            {
              large: "/viewer/400_14s.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_14s.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XBO14S",
            },
   
        ]
      },
      { 
        id: "3.5", 
        name: "XBO8L", 
        title:"low profile dip8 ",
        relativeData: "XBO8L 16x15.3x7.5 mm", //add
        partNumberServiceData:  combinationOCXO1,
        pdfUrl: "/pimages/03_pdf/XBO8.pdf",
        description: "Low profile", 
        size: "16x15.3x7.5", 
        color: "bg-gradient-to-br from-emerald-500 to-emerald-600",
        image: "/viewer/200_8d.png",
        scaleImage: 0.6,
        modelParamsComponentCode: 1, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8-150 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Stability", value: "1ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
          { label: "Aging", value: "0.2 ppb/day", icon: 'CalendarClock', mobileDisplay: true },
          { label: "Phase Noise", value: "-100 dBc/Hz@1Hz", icon: 'BarChart3', mobileDisplay: true },
          { label: "Consumption", value: "<100 mW", icon: 'Zap', mobileDisplay: true }, 
         ],
        availableMultipliers: graph_data_xbo8.availableMultipliers, //add
        data: graph_data_xbo8.data, //add
        imagesViewer:[
            {
              large: "/viewer/400_8d.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_8d.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XBO8L",
            },
   
        ]
      },
      { 
        id: "3.6", 
        name: "XBO14L", 
        title:"low profile dip14 ",
        relativeData: "XBO14L 16x15.3x7.5 mm", //add
        partNumberServiceData:  combinationOCXO1,
        pdfUrl: "/pimages/03_pdf/XBO14-L.pdf",//app/frontend/public/pimages/03_pdf/XBO14-L.pdf
        description: "Low profile", 
        size: "20.5x15.3x15.8", 
        color: "bg-gradient-to-br from-emerald-500 to-emerald-600",
        image: "/viewer/200_14L.png",
        scaleImage: 0.7,
        modelParamsComponentCode: 1, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8-150 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Stability", value: "1ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
          { label: "Aging", value: "0.1 ppb/day", icon: 'CalendarClock', mobileDisplay: true },
          { label: "Phase Noise", value: "-105 dBc/Hz@1Hz", icon: 'BarChart3', mobileDisplay: true },
          { label: "Consumption", value: "<120 mW", icon: 'Zap', mobileDisplay: true }, 
         ],
        availableMultipliers: graph_data_xbo8.availableMultipliers, //add
        data: graph_data_xbo8.data, //add
        imagesViewer:[
            {
              large: "/viewer/400_14L.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_14L.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XBO14L",
            },
   
        ]
      }
    ]
  },
  {
    id: 4,
    caption: "Low power shock resistant OCXOs",
    title:"shock resistant",
    color: "bg-slate-50/70 dark:bg-slate-900/50 border-x border-slate-200 dark:border-slate-800",
    headerGradient: "from-[#4f5aa3] to-[#5c67aa]",
    pdfUrl: "/specs/xbo-shock-resistant-specification.pdf",
    layoutOcxoParams: "A2LayoutOcxoParams",
    //isLowPower: true,
    specifications: [
      { label: "Stability", value: "5 ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true} ,
      { label: "Aging", value: "0.3 ppb/day", icon: 'CalendarClock', mobileDisplay: true },
      { label: "Shock Resistance", value: "to 1000g, 1ms", icon: 'CannabisIcon', mobileDisplay: true },
      
    ],
    products: [
      { 
        id: "4.1", 
        name: "XBO8D", 
        title:"shock resistant dip8",
        relativeData: "XBO8D 16x15.3x15.8 mm", //add
        partNumberServiceData:  combinationOCXO1,
        pdfUrl: "/pimages/03_pdf/XBO8.pdf",
        size: "16x15.3x15.8 mm", 
        color: "bg-gradient-to-br from-amber-100 to-amber-200",
        image: "/viewer/200_8.png",
        scaleImage: 0.6,
        modelParamsComponentCode: 1, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8-150 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Shock Resistance", value: "to 1000g, 1ms", icon: 'CannabisIcon', mobileDisplay: true },
          { label: "Stability", value: "10ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
          { label: "Aging", value: "0.3 ppb/day", icon: 'CalendarClock', mobileDisplay: true },
          { label: "Consumption", value: "<150 mW", icon: 'Zap', mobileDisplay: true },
        ],
        availableMultipliers: graph_data_xbo8.availableMultipliers, //add
        data: graph_data_xbo8.data, //add
        imagesViewer:[
            {
              large: "/viewer/400_8.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_8.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XBO8D",
            },
 
        ]
      },
      { 
        id: "4.2", 
        name: "XBO14D", 
        title:"shock resistant dip14",
        relativeData: "XB14D 20.5x15.3x15.8 mm", //add
        partNumberServiceData:  combinationOCXO1,
        pdfUrl: "/pimages/03_pdf/XBO14.pdf",
        size: "20.5x15.3x15.8 mm", 
        color: "bg-gradient-to-br from-amber-200 to-amber-300",
        image: "/viewer/200_14.png",
        scaleImage: 0.7,
        modelParamsComponentCode: 1, //add 1-> 'axl2/OcxoParams/A1LayoutOcxoParams.jsx'
        technicalDetails: [
          { label: "Frequency", value: "8-150 MHz", icon: 'Radio', mobileDisplay: true },
          { label: "Shock Resistance", value: "to 1000g, 1ms", icon: 'CannabisIcon', mobileDisplay: true },    
          { label: "Stability", value: "10ppb (-40 +85)˚C", icon: 'Thermometer', mobileDisplay: true },
          { label: "Aging", value: "0.3 ppb/day", icon: 'CalendarClock', mobileDisplay: true },
          { label: "Consumption", value: "<150 mW", icon: 'Zap', mobileDisplay: true },
      
        ],
        availableMultipliers: graph_data_xbo14.availableMultipliers, //add
        data: graph_data_xbo14.data, //add
        imagesViewer:[
            {
              large: "/viewer/400_14.png", //imagePath: "./pimages/img_axl/02_products"
              thumb: "/viewer/150_14.png", //imagePath: "./pimages/img_axl/02_products"
              alt: "XBO14D",
            },
     
        ]
      }
    ]
  }
];

/* 
*******************
Slice store/productsSlice.js
*******************
*/
// Helper function to find product by ID
export const findProductById = (productId) => {
  //console.log("Hello from findProductById")
  for (const group of PRODUCTS_BASE_DATA) {
    const product = group.products.find(p => p.id === productId);
    if (product) {
            // Get relative descriptions from other products in same group
      const relativeDescriptions = group.products
        .map(p => p.relativeData)
        .filter(Boolean); // Remove undefined/null
            // Get names array ["2.1", "2.2"] etc.
      const relativeIdArray = group.products
        .map(p => p.id) // Extract just the name property
        .filter(Boolean); // Remove undefined/null
      
      // Get current product index
      const currentIndex = group.products.findIndex(p => p.id === productId);

      return {
        product,
        relativeProducts: {
          descrArray: relativeDescriptions, // Just the descriptions
          activeIndex: currentIndex,
          idArray: relativeIdArray,
        },
        parentGroup: {
          id: group.id,
          caption: group.caption,
          title: group.title,
          pdfUrl: group.pdfUrl,
          layoutOcxoParams: group.layoutOcxoParams,
          specifications: group.specifications,
          isLowPower: group.isLowPower,
          color: group.color,
          headerGradient: group.headerGradient
        },
        testField: "testProductData",
      };
    }
  }
  return null;
};

// Helper function to flatten all products
//It needs for the FrontPage
export const getAllFlattenedProducts = () => {
  const flattenedProducts = [];
  
  PRODUCTS_BASE_DATA.forEach(group => {
    group.products.forEach(product => {
      flattenedProducts.push({
        ...product,
        groupId: group.id,
        groupCaption: group.caption,
        groupSpecifications: group.specifications,
        groupPdfUrl: group.pdfUrl,
        isLowPower: group.isLowPower
      });
    });
  });
  //console.log(flattenedProducts)
  return flattenedProducts;
};


/* 
*******************
Slice store/productGroupSlice.js
*******************
*/

// Helper function to get all product groups (for frontpage)
export const getAllProductGroups = () => {
  return PRODUCTS_BASE_DATA.map(group => ({
    id: group.id,
    caption: group.caption,
    title: group.title,
    color: group.color,
    headerGradient: group.headerGradient,
    pdfUrl: group.pdfUrl,
    isLowPower: group.isLowPower,
    specifications: group.specifications, // Keep icon as string
    products: group.products.map(product => ({
      id: product.id,
      name: product.name,
      title: product.title,
      pdfUrl: product.pdfUrl,
      technicalDetails: product.technicalDetails,
      //relativeData: product.relativeData,
      size: product.size,
      color: product.color,
      image: product.image,
      scaleImage: product.scaleImage,
      // Don't include technicalDetails for frontpage
    }))
  }));
};
